import { removeSpaces, spacesInCamelCase } from "core/utils";
import { keys } from "lodash";
import { TestSuiteType } from "models/project";
import { ReactNode } from "react";
import { JsxElement } from "typescript";
import Select from "./select";

interface Props {
  value: TestSuiteType;
  onChange: (value: TestSuiteType) => any;
  error?: boolean | string;
  label?: string | JsxElement | ReactNode;
}

const TestSuiteTypeSelect = ({ onChange, value, error, label }: Props) => {
  let values = keys(TestSuiteType);

  return (
    <Select
      className="test-suite-type-select"
      onChange={(v) => onChange(TestSuiteType[removeSpaces(v)])}
      value={spacesInCamelCase(value)}
      options={values.map(spacesInCamelCase)}
      error={error}
      label={label}
    />
  );
};

export default TestSuiteTypeSelect;
